var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getUniqueDeviceOptions from './getUniqueDeviceOptions';
var attributeSelectionReducer = function (state, action) {
    var _a, _b, _c, _d, _e;
    var deviceData = state.deviceData;
    switch (action.type) {
        case 'UPDATE_INITIAL_STATE': {
            var initialState = action.payload.initialState;
            return __assign({}, initialState);
        }
        case 'UPDATE_COLOR': {
            var color = action.payload.color;
            return __assign(__assign({}, state), { color: color });
        }
        case 'UPDATE_STORAGE': {
            var storage_1 = action.payload.storage;
            // Find the first device containing the selected color, condition and storage.
            var foundSelectedOptions = deviceData.find(function (device) {
                var _a, _b, _c;
                return ((_a = device === null || device === void 0 ? void 0 : device.storage) === null || _a === void 0 ? void 0 : _a.id) === storage_1 &&
                    ((_b = device === null || device === void 0 ? void 0 : device.color) === null || _b === void 0 ? void 0 : _b.id) === state.color &&
                    ((_c = device === null || device === void 0 ? void 0 : device.condition) === null || _c === void 0 ? void 0 : _c.id) === state.condition;
            });
            if (foundSelectedOptions) {
                return __assign(__assign({}, state), { storage: storage_1, deviceOptions: getUniqueDeviceOptions(deviceData, state.condition, storage_1) });
            }
            // If no devices are found with the selected color, condition and storage
            // set the color to be for the first device found with selected storage and condition.
            var firstDevice = deviceData.find(function (device) {
                var _a, _b, _c;
                return ((_a = device === null || device === void 0 ? void 0 : device.color) === null || _a === void 0 ? void 0 : _a.id) &&
                    ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id) === storage_1 &&
                    ((_c = device === null || device === void 0 ? void 0 : device.condition) === null || _c === void 0 ? void 0 : _c.id) === state.condition;
            });
            return __assign(__assign({}, state), { colorNotFound: true, color: (_a = firstDevice === null || firstDevice === void 0 ? void 0 : firstDevice.color) === null || _a === void 0 ? void 0 : _a.id, storage: storage_1, deviceOptions: getUniqueDeviceOptions(deviceData, state.condition, storage_1) });
        }
        case 'UPDATE_CONDITION': {
            var condition_1 = action.payload.condition;
            // Find the first device containing the selected condition and storage.
            var foundConditionStorage = deviceData.find(function (device) { var _a, _b; return ((_a = device === null || device === void 0 ? void 0 : device.storage) === null || _a === void 0 ? void 0 : _a.id) === state.storage && ((_b = device === null || device === void 0 ? void 0 : device.condition) === null || _b === void 0 ? void 0 : _b.id) === condition_1; });
            if (foundConditionStorage) {
                // Find the first device containing the selected condition, storage and color.
                var foundSelectedOptions = deviceData.find(function (device) {
                    var _a, _b, _c;
                    return ((_a = device === null || device === void 0 ? void 0 : device.color) === null || _a === void 0 ? void 0 : _a.id) === state.color &&
                        ((_b = device === null || device === void 0 ? void 0 : device.storage) === null || _b === void 0 ? void 0 : _b.id) === state.storage &&
                        ((_c = device === null || device === void 0 ? void 0 : device.condition) === null || _c === void 0 ? void 0 : _c.id) === condition_1;
                });
                if (foundSelectedOptions) {
                    return __assign(__assign({}, state), { condition: condition_1, deviceOptions: getUniqueDeviceOptions(deviceData, condition_1, state.storage) });
                }
                // If no devices are found with the selected condition, storage and color
                // set the color to be for the first device found with selected condition and storage.
                var firstDevice_1 = deviceData.find(function (device) {
                    var _a, _b;
                    return (device === null || device === void 0 ? void 0 : device.color) &&
                        ((_a = device === null || device === void 0 ? void 0 : device.storage) === null || _a === void 0 ? void 0 : _a.id) === state.storage &&
                        ((_b = device === null || device === void 0 ? void 0 : device.condition) === null || _b === void 0 ? void 0 : _b.id) === condition_1;
                });
                return __assign(__assign({}, state), { colorNotFound: true, color: (_b = firstDevice_1 === null || firstDevice_1 === void 0 ? void 0 : firstDevice_1.color) === null || _b === void 0 ? void 0 : _b.id, condition: condition_1, deviceOptions: getUniqueDeviceOptions(deviceData, condition_1, state.storage) });
            }
            // If no devices are found with the selected condition and storage
            // set all the options to be for the first device found with selected condition.
            var firstDevice = deviceData.find(function (device) { var _a; return ((_a = device === null || device === void 0 ? void 0 : device.condition) === null || _a === void 0 ? void 0 : _a.id) === condition_1; });
            return __assign(__assign({}, state), { color: (_c = firstDevice === null || firstDevice === void 0 ? void 0 : firstDevice.color) === null || _c === void 0 ? void 0 : _c.id, storage: (_d = firstDevice === null || firstDevice === void 0 ? void 0 : firstDevice.storage) === null || _d === void 0 ? void 0 : _d.id, condition: condition_1, deviceOptions: getUniqueDeviceOptions(deviceData, condition_1, (_e = firstDevice === null || firstDevice === void 0 ? void 0 : firstDevice.storage) === null || _e === void 0 ? void 0 : _e.id) });
        }
        case 'SHOW_ERROR': {
            return __assign(__assign({}, state), { colorNotFound: action.payload });
        }
        default:
            return state;
    }
};
export default attributeSelectionReducer;
